module.exports = __webpack_public_path__ + "static/img/OMENXIII.cd06038.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/OMENXIII.jpg
// module id = Kosj
// module chunks = 1